export default __webpack_public_path__ + "static/media/H91A2298.2c3641c7.jpg";